export type OnboardingStep = {
  title: string;
  description: string;
  highlightTarget: "agenda" | "agenda-toggle" | "prenota" | "colleghi" | null;
  route: "/" | "/dichiara" | "/profile" | null;
};

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    title: "Benvenuto su WorkIn",
    description: "WorkIn ti aiuta a coordinare la presenza in ufficio con il tuo team, in modo semplice e immediato.",
    highlightTarget: null,
    route: null,
  },
  {
    title: "Agenda condivisa",
    description:
      "Da qui vedi la tua giornata e il riepilogo mensile. È il punto di partenza per coordinarti con il team.",
    highlightTarget: "agenda",
    route: "/",
  },
  {
    title: "La mia vs Tutti",
    description:
      "Usa il toggle per passare dalla tua vista a quella del team: vedi dove lavorano tutti i tuoi colleghi connessi.",
    highlightTarget: "agenda-toggle",
    route: "/",
  },
  {
    title: "Colleghi connessi",
    description:
      "Connettiti con i tuoi colleghi: richiedi di vedere la loro agenda o condividi la tua. Il coordinamento diventa molto più facile.",
    highlightTarget: "colleghi",
    route: "/profile",
  },
  {
    title: "Dichiara la tua presenza",
    description:
      "Dichiara dove lavori ogni giorno — in ufficio, smart working, ferie, permesso o dal cliente — e prenota la tua scrivania.",
    highlightTarget: "prenota",
    route: "/dichiara",
  },
];
